import { render } from "./ValidationResultContainer.vue?vue&type=template&id=272dfe32"
import script from "./ValidationResultContainer.vue?vue&type=script&lang=js"
export * from "./ValidationResultContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__